<script setup lang="ts">

import LGReviewCarousel from "~/components/partials/LGReviewCarousel.vue";
</script>

<template>
    <section class="pb-70 sm:pb-80 bg-[#FAEFEE] relative overflow-x-clip">
        <NuxtImg src="/images/shop/shop-review-pin.svg" alt="Pin" class="hidden lg:block lg:w-[208px] absolute lg:-top-8 lg:left-0" />
        <NuxtImg src="/images/shop/shop-reviews-top-bg.svg" alt="Top background" class="w-full h-auto" />
        <div class="pt-16 lg:pt-36">
            <LGReviewCarousel/>
        </div>
    </section>
</template>

<style scoped>

</style>
